:host {
    display: flex;
    width: 100%;
    justify-content: flex-end;

    * {
        box-sizing: border-box;
    }

}

.action-bar {
    display: flex;
}

app-menu {
    box-shadow: var(--md-sys-elevation-level-2);
    background-color: white;
    z-index: 999;
}